"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[133],{

/***/ 4393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_FormPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/views/BasePage/index.tsx + 1 modules
var BasePage = __webpack_require__(4257);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Form/FormFields/index.tsx + 39 modules
var FormFields = __webpack_require__(3432);
// EXTERNAL MODULE: ./src/components/RawHtml/index.tsx + 2 modules
var RawHtml = __webpack_require__(580);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(844);
// EXTERNAL MODULE: ./src/streamfields/Streamfields.tsx + 40 modules
var Streamfields = __webpack_require__(1594);
// EXTERNAL MODULE: ./src/components/Hero/index.tsx + 3 modules
var Hero = __webpack_require__(1223);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(2983);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/BannerImage/BannerImage.tsx



function BannerImage(props) {
    const { image  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "banner-image",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: (0,url/* addBaseUrl */.gI)(image.meta.download_url),
            alt: image.title,
            fill: true,
            priority: true
        })
    });
}
/* harmony default export */ var BannerImage_BannerImage = (BannerImage);

;// CONCATENATED MODULE: ./src/components/BannerImage/index.tsx

/* harmony default export */ var components_BannerImage = (BannerImage_BannerImage);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/views/FormPage/FormPage.tsx










function FormPage(props) {
    const router = (0,next_router.useRouter)();
    const { title ="" , subtitle , form_fields: formFields , before_form: beforeForm , after_form: afterForm , thank_you_text: thankYouText , banner_image: bannerImage  } = props;
    const [status, setStatus] = (0,react.useState)("idle");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "form-page",
        children: [
            bannerImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BannerImage, {
                image: bannerImage
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                title: title,
                subtitle: subtitle
            }),
            beforeForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Streamfields/* default */.Z, {
                fields: beforeForm
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                id: "formular",
                className: "form",
                method: "POST",
                onSubmit: async (event)=>{
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    // only has value if filled by bot
                    if (formData.get("decoy-comments")) return;
                    const data = Object.fromEntries(formData);
                    formFields.forEach((field)=>{
                        if (field.field_type !== "checkboxes") return;
                        data[field.clean_name] = formData.getAll(field.clean_name);
                    });
                    try {
                        var _props_form_fields, _props_form_fields_;
                        setStatus("loading");
                        const res = await fetch("".concat("https://busche-zelte.de/api", "/v2/forms/"), {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                page: (_props_form_fields = props.form_fields) === null || _props_form_fields === void 0 ? void 0 : (_props_form_fields_ = _props_form_fields[0]) === null || _props_form_fields_ === void 0 ? void 0 : _props_form_fields_.page_id,
                                form_data: data
                            })
                        });
                        if (res.ok) {
                            setStatus("success");
                        } else {
                            setStatus("error");
                        }
                    } catch (error) {
                        setStatus("error");
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormFields/* default */.Z, {
                        formFields: formFields.map((formField)=>{
                            const out = {
                                ...formField
                            };
                            const value = router.query[formField.clean_name];
                            if (value) {
                                out.default_value = Array.isArray(value) ? value === null || value === void 0 ? void 0 : value[0] : value;
                            }
                            return out;
                        })
                    }),
                    status === "success" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "message message--success",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RawHtml/* default */.Z, {
                            html: thankYouText
                        })
                    }) : null,
                    status === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "message message--error",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Leider ist etwas schief gegangen... Bitte versuchen Sie es sp\xe4ter erneut..."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Alternativ k\xf6nnen Sie Ihre Anfrage auch direkt an die E-Mail-Adresse",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:info@busche-zelte.de",
                                        children: "info@busche-zelte.de"
                                    }),
                                    " senden."
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        primary: true,
                        type: "submit",
                        disabled: status === "loading" || status === "success",
                        className: "form__submit",
                        children: "Absenden"
                    })
                ]
            }),
            afterForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Streamfields/* default */.Z, {
                fields: afterForm
            }) : null
        ]
    });
}
/* harmony default export */ var FormPage_FormPage = ((0,BasePage/* basePageWrap */.P)(FormPage));

;// CONCATENATED MODULE: ./src/views/FormPage/index.tsx

/* harmony default export */ var views_FormPage = (FormPage_FormPage);


/***/ })

}]);